import { put, takeEvery } from 'redux-saga/effects';
import * as ActionTypes from '../../../action/actionTypes';
import { initializeApplicationStartup } from '../actions';

export default function* mobileInitializerTransaction() {
	yield takeEvery(ActionTypes.MOBILE_INITIALIZER, mobileFormInitilizer);
}

function* mobileFormInitilizer() {
	yield put(initializeApplicationStartup());
	yield put({
		type: 'APP_MAIN_MODULE.OPEN_MOBILE_FORM_TRANSACTION'
	});
}
